module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico_arrow_triangle_right-b8fb9cf70229e5372880229f0daadc6d.svg";